import { __assign } from "tslib";
import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Status.scss';
var StatusThumbReactView = function (props) { return (React.createElement("div", { className: s['root'], style: { width: props.width, height: props.height } },
    React.createElement(MinimalDumbo, __assign({}, props)))); };
StatusThumbReactView.displayName = 'StatusThumbReactView';
export default StatusThumbReactView;
//# sourceMappingURL=Status.js.map